import React from "react";
import { FaDirections } from "react-icons/fa";

export const DirectionsLink = ({ name, address }) => {
  return (
    <section>
      <a
        href={`https://www.google.com/maps?q=${name} ${address.address} ${address.city}, ${address.state} ${address.zipcode}`}
      >
        <span className="pe-2">
          <FaDirections style={{ color: "#000000" }} />
        </span>
        Directions
      </a>
    </section>
  );
};
